import { render, staticRenderFns } from "./ReportsLayout.vue?vue&type=template&id=1c22ed11&scoped=true"
import script from "./ReportsLayout.vue?vue&type=script&lang=js"
export * from "./ReportsLayout.vue?vue&type=script&lang=js"
import style0 from "./ReportsLayout.vue?vue&type=style&index=0&id=1c22ed11&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c22ed11",
  null
  
)

export default component.exports